import { auth, functions, db } from "./firebase";
import { httpsCallable } from "firebase/functions";
import { doc, getDoc } from "firebase/firestore";
import { accountStorage } from "./accountStorage";

const CADENCE_KEY = "axoris.mock.cadence";

export async function getCadenceOptIn() {
  const user = auth.currentUser, cache = accountStorage();
  if (!user || !cache.isCurrent()) return false;
  try {
    const userDoc = await getDoc(doc(db, "users", user.uid));
    if (!cache.isCurrent()) return false;
    if (userDoc.exists()) {
      const optIn = !!userDoc.data()?.cadenceOptIn;
      cache.write(CADENCE_KEY, optIn);
      return optIn;
    }
    cache.write(CADENCE_KEY, false);
    return false;
  } catch {
    return cache.read(CADENCE_KEY, false) === true;
  }
}

export async function setCadenceOptIn(optIn) {
  const user = auth.currentUser, cache = accountStorage();
  if (!user || !cache.isCurrent()) return { error: "fail" };
  try {
    const fn = httpsCallable(functions, "setCadenceOptIn");
    const res = await fn({ optIn: Boolean(optIn) });
    if (!cache.isCurrent()) return { error: "fail" };
    if (res.data?.ok) {
      cache.write(CADENCE_KEY, res.data.cadenceOptIn === true);
      return { ok: true, cadenceOptIn: res.data.cadenceOptIn };
    }
    return { error: "fail" };
  } catch (err) {
    return { error: err?.message || "fail" };
  }
}
